import { PageRef } from 'providers/page-ref';

export type TestUiToastsPageParams = {};

export const ITestUiToastsPage: PageRef<TestUiToastsPageParams, void> = {
  pageName: 'TestUiToastsPage',
} as PageRef<TestUiToastsPageParams, void>;
